<app-header [authenticatorHome]="true"></app-header>
<section
  role="main"
  class="bg-body-secondary h-100 pt-0 index-page"
>
  <!-- SCHEMATA INIZIALE CON SCELTA ACCESSO -->
  
  <div class="home-img d-flex justify-content-center align-items-center">
    <div class="bg-white rounded box-shadow-base p-3">
      <div class="flex-column justify-content-around align-items-center responsive-align">
        <div class="col-12 ms-max-width pb-3">
          <h1 class="pt-3 pb-4 ps-4">Seleziona il metodo di accesso</h1>
          @if (sessionTimedOut) {
          <p class="text-start text-danger">
            Sessione scaduta ! Effettua nuovamente l'accesso.
          </p>
          }
          <p class="p-0 m-0 px-4"></p>
        </div>
        <div class="ms-container pb-3">
          <div
            class="col-12 row justify-content-start px-4 px-md-0 justify-content-md-around align-items-center p-3"
            style="gap: 54px; margin-top: -30px"
          >
            <!-- Inizio card spid -->
            <div class="col-12 col-sm-9 col-md-5 col-lg-4 col-xl-3 access-card">
              <div class="flex-grow-1 m-4">
                <img
                src="assets/images/SPID.png"
                alt=""
                width="250"
                />
              </div>
              <div class="access-card-content">
                <h3 class="m-0">Accedi con SPID</h3>
                <p class="overflow-y-auto">
                  SPID è il Sistema Pubblico di Identità Digitale per accedere ai
                  servizi online della Pubblica Amministrazione.
                </p>
                @if (loginLevel == 0) {
                <app-button
                  colore="primary"
                  outlined="false"
                  (click)="autenticazione(3)"
                  class="bg-hover"
                >
                  Accedi
                </app-button>
                }
              </div>
            </div>
            <!-- Card Entra -->
              <div class="col-12 col-sm-9 col-md-5 col-lg-4 col-xl-3 access-card">
                <div class="flex-grow-1">
                  <img
                  src="assets/images/Entra.png"
                  alt=""
                  width="200"/>
                </div>
                <div class="access-card-content">
                  <h3 class="m-0">Accedi con Entra</h3>
                  <p class="overflow-y-auto">
                    Entra è il protocollo di Identità Digitale per accedere ai servizi
                    online di APSS.
                  </p>
                  @if (loginLevel == 0) {
                  <app-button
                    colore="primary"
                    outlined="false"
                    (click)="autenticazione(2)"
                    class="bg-hover"
                  >
                    Accedi
                  </app-button>
                  }
                </div>
              </div>
            <!-- Card email/password-->
            <!-- <div class="col-12 col-sm-9 col-md-5 col-lg-3 col-xl-3 access-card">
              <img src="assets/images/CIE.svg" alt="" width="220" />
              <div class="access-card-content">
                <h3 class="m-0">Accedi con e-mail e password</h3>
                <p class="overflow-y-auto">
                  Accedi con la tua email e password ai servizi che non richiedano
                  un'autenticazione forte.
                </p>
                @if (loginLevel == 0) {
                <app-button
                  colore="primary"
                  outlined="false"
                  (click)="autenticazione(1)"
                  class="bg-hover"
                >
                  Accedi
                </app-button>
                }
              </div>
            </div> -->
          </div>
        </div>
        <p class="ps-4 pt-4">
          I metodi di autenticazione forte SPID e LDAP ti danno accesso a tutte le
          funzionalità del portale. L’accesso con email e password è un metodo di
          autenticazione debole, e ti dà accesso a un numero limitato di servizi.
        </p>
      </div>
    </div>
  </div>
</section>
